import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Clock, Navigation, Calendar, Mail } from 'lucide-react';
import { BUSINESS } from '../../lib/data';
import Reveal from '../ui/Reveal';

export default function LocationCta() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white to-pink-50/60">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-6 md:gap-8">
          {/* Visit card */}
          <Reveal>
            <div className="bg-white rounded-3xl shadow-xl shadow-pink-100/50 border border-pink-50 p-7 md:p-9 h-full">
              <h2 className="font-display text-3xl md:text-4xl font-black text-ink-900">Come say hello</h2>
              <div className="mt-6 space-y-5">
                <div className="flex items-start space-x-4">
                  <span className="bg-pink-100 rounded-2xl p-3"><MapPin className="w-5 h-5 text-pink-600" /></span>
                  <div>
                    <p className="font-bold text-gray-900 text-sm">Address</p>
                    <p className="text-gray-600 text-sm mt-0.5">{BUSINESS.address}</p>
                    <a
                      href={BUSINESS.mapsUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="mt-1.5 inline-flex items-center space-x-1 text-sm font-bold text-cyan-600 hover:text-cyan-700"
                    >
                      <Navigation className="w-3.5 h-3.5" />
                      <span>Get directions</span>
                    </a>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <span className="bg-emerald-100 rounded-2xl p-3"><Phone className="w-5 h-5 text-emerald-600" /></span>
                  <div>
                    <p className="font-bold text-gray-900 text-sm">Call or text</p>
                    <a href={BUSINESS.phoneHref} className="text-gray-600 text-sm mt-0.5 hover:text-pink-600 font-semibold">{BUSINESS.phone}</a>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <span className="bg-blue-100 rounded-2xl p-3"><Mail className="w-5 h-5 text-blue-600" /></span>
                  <div>
                    <p className="font-bold text-gray-900 text-sm">Email</p>
                    <a href={`mailto:${BUSINESS.email}`} className="text-gray-600 text-sm mt-0.5 hover:text-pink-600 font-semibold">{BUSINESS.email}</a>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <span className="bg-purple-100 rounded-2xl p-3"><Clock className="w-5 h-5 text-purple-600" /></span>
                  <div className="grow">
                    <p className="font-bold text-gray-900 text-sm mb-1.5">Hours</p>
                    {BUSINESS.hours.map((h) => (
                      <div key={h.days} className="flex justify-between gap-4 text-sm text-gray-600 py-0.5">
                        <span>{h.days}</span>
                        <span className="font-semibold text-gray-800">{h.time}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          {/* CTA card */}
          <Reveal delay={0.12}>
            <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-pink-500 via-purple-500 to-cyan-500 p-8 md:p-10 h-full flex flex-col justify-center text-white shadow-2xl">
              <div aria-hidden className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-white/10 blur-2xl" />
              <div aria-hidden className="absolute -bottom-20 -left-10 w-64 h-64 rounded-full bg-white/10 blur-3xl" />
              <h2 className="relative font-display text-4xl md:text-5xl font-black leading-[1.05] tracking-tight">
                Ready for the best
                <br />spa day ever?
              </h2>
              <p className="relative mt-3 text-white/85 max-w-md">
                Slots fill fast — especially weekends. Book online in under two minutes,
                or call and we'll find a time together.
              </p>
              <div className="relative mt-7 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/booking"
                  className="inline-flex items-center justify-center space-x-2 bg-white text-pink-600 hover:bg-pink-50 px-7 py-3.5 rounded-full font-extrabold shadow-xl transition-all duration-300 hover:scale-[1.03]"
                >
                  <Calendar className="w-5 h-5" />
                  <span>Book a Spa Day</span>
                </Link>
                <a
                  href={BUSINESS.phoneHref}
                  className="inline-flex items-center justify-center space-x-2 bg-white/15 hover:bg-white/25 backdrop-blur border border-white/40 px-7 py-3.5 rounded-full font-bold transition-colors"
                >
                  <Phone className="w-5 h-5" />
                  <span>{BUSINESS.phone}</span>
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
